import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(form.email, form.password);
    setLoading(false);
    if (res.success) {
      navigate(location.state?.from?.pathname || "/account");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="text-center mb-8">
        <FlaskConical className="h-8 w-8 text-brandblue-600 mx-auto mb-3" strokeWidth={1.5} />
        <h1 className="text-2xl font-display font-medium text-slate-900">Research Login</h1>
        <p className="text-sm text-slate-500 mt-1">Access your research account.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" /></div>
        <div><Label>Password</Label><Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" /></div>
        {error && <p className="text-xs text-red-500" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full rounded-full btn-lift" data-testid="login-submit-btn">
          {loading ? "Signing In..." : "Research Login"}
        </Button>
      </form>

      <div className="text-center mt-5 space-y-2">
        <Link to="/forgot-password" className="text-xs text-brandblue-600 font-semibold" data-testid="forgot-password-link">Forgot password?</Link>
        <p className="text-sm text-slate-500">Don't have an account? <Link to="/register" className="text-brandblue-600 font-semibold" data-testid="go-to-register-link">Register</Link></p>
      </div>
    </div>
  );
}
